import styled from 'styled-components';
import { devices } from '@styles/global';
import { Link } from 'react-router-dom';

export const TopBarContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: var(--app-topbar-height);
  background: #1A4D3A;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1200;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  overflow: visible;
`;

export const TopBarContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  padding: 0 var(--app-topbar-padding-inline);
  gap: var(--app-topbar-gap);
  max-width: 100%;
  min-width: 0;
  overflow: visible;

  @media (max-width: ${devices.tablet}) {
    padding: 0 var(--app-topbar-padding-inline);
    gap: var(--app-topbar-gap);
  }
`;

export const LogoSection = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
  flex-shrink: 0;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }
`;

export const SearchSection = styled.form`
  flex: 1;
  max-width: min(100%, var(--app-search-max-width));
  position: relative;
  display: flex;
  align-items: center;
  z-index: 1;

  @media (max-width: ${devices.tablet}) {
    max-width: 220px;
  }

  @media (max-width: 640px) {
    display: none;
  }
`;

export const SearchIcon = styled.div`
  position: absolute;
  left: 12px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 16px;
  pointer-events: none;
  z-index: 1;
`;

export const SearchInput = styled.input`
  width: 100%;
  min-height: var(--app-control-min-height);
  padding: 7px 12px 7px 38px;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  color: white;
  font-size: var(--font-size-sm);
  transition: all 0.2s;

  &::placeholder {
    color: rgba(255, 255, 255, 0.5);
  }

  &:focus {
    outline: none;
    background: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.4);
  }
`;

export const ActionsSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;

  html[data-layout-density='compact'] & {
    gap: 8px;
  }

  @media (max-width: 640px) {
    gap: 8px;
  }
`;

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--app-control-min-height);
  height: var(--app-control-min-height);
  background: rgba(255, 255, 255, 0.1);
  border: none;
  border-radius: 8px;
  color: white;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 16px;
  position: relative;
  text-decoration: none;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }

  @media (max-width: 640px) {
    width: 36px;
    height: 36px;
    font-size: 16px;
  }
`;

export const ProfileButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: var(--app-control-min-height);
  padding: 4px 10px;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  border-radius: 8px;
  color: white;
  cursor: pointer;
  transition: all 0.2s;
  font-size: var(--font-size-sm);
  font-weight: 500;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }

  html[data-viewport-profile='notebook'] & {
    padding: 4px 8px;

    span {
      display: none;
    }
  }

  @media (max-width: 640px) {
    padding: 6px;
    gap: 0;

    span {
      display: none;
    }
  }
`;

export const ProfileAvatar = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: white;
  color: #1A4D3A;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 12px;
  flex-shrink: 0;
`;

export const SearchResults = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  right: 0;
  background: white;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  max-height: 400px;
  overflow-y: auto;
  z-index: 1300;
  border: 1px solid rgba(15, 23, 42, 0.08);

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
  }
`;

export const SearchResultItem = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  width: 100%;
  background: transparent;
  border: none;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.15s;
  color: #1A4D3A;

  &:hover,
  &:focus {
    background: rgba(26, 77, 58, 0.08);
    outline: none;
  }

  &:first-child {
    border-radius: 12px 12px 0 0;
  }

  &:last-child {
    border-radius: 0 0 12px 12px;
  }
`;

export const SearchResultIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  font-size: 18px;
  color: #1A4D3A;
  flex-shrink: 0;
  background: rgba(26, 77, 58, 0.1);
  border-radius: 8px;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const SearchResultLabel = styled.div`
  font-size: var(--font-size-sm);
  font-weight: 600;
  color: #1A4D3A;
  margin-bottom: 2px;
`;

export const SearchResultCategory = styled.div`
  font-size: 12px;
  color: #666;
  font-weight: 400;
`;

export const MobileMenuButton = styled.button`
  display: none;
  align-items: center;
  justify-content: center;
  width: var(--app-control-min-height);
  height: var(--app-control-min-height);
  background: rgba(255, 255, 255, 0.1);
  border: none;
  border-radius: 8px;
  color: white;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 18px;
  flex-shrink: 0;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }

  @media (max-width: ${devices.tablet}) {
    display: flex;
  }
`;
